import { FormControlLabel, Radio, RadioProps, styled, Typography } from '@mui/material';
import { green, grey6, red2, white } from 'app/components/ThemeProvider/colors';
import React from 'react';
import { Controller } from 'react-hook-form';
import logger from 'app/utils/logger';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  backgroundColor: white,
  border: `2px solid ${grey6}`,
  padding: '0 !important',

  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: green,
  border: 'none',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: green,
  },
});

const BpDisabledCheckedIcon = styled(BpIcon)({
  backgroundColor: 'rgba(20, 25, 31, 0.1)',
  border: 'none',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: 'rgba(20, 25, 31, 0.1)',
  },
});

const BpRadio = (props: any) => {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={props.disabled ? <BpDisabledCheckedIcon /> : <BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
      sx={{ p: 0, pr: '8px' }}
    />
  );
};

interface Props {
  title: string;
  value?: string;
  handleChange?: (e: any) => void;
  mr?: string;
  checked?: boolean;
  rest?: any;
  control?: any;
  isValid?: boolean;
  disabled?: boolean;
}

const CustomRadio = (props: Props) => {
  const { title, value, handleChange, mr, checked, rest, control, isValid, disabled } = props;

  return (
    // <Controller
    //   render={({ field: { onChange: onChangeInput, ref } }) => (
    <FormControlLabel
      sx={{ mr, ml: 0 }}
      control={<BpRadio checked={checked} disabled={disabled} />}
      label={<Typography>{title}</Typography>}
      disabled={disabled}
      value={value}
      onChange={handleChange}
    />
    // )}
    // control={control}
    // name={rest.name}
    // />
  );
};

export default CustomRadio;
